<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="/">
      <img src="assets/images/icon.png" alt="Nodum Icon" class="nodum-icon" />
      <span>Nodum Hub</span>
    </a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">

    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [shape]="'semi-round'"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
